<template>
  <div class="sub-sidebar-menu">
    <!-- 二级菜单标题（面包屑） -->
    <div class="sub-title">
      <slot name="title">{{ title }}</slot>
    </div>

    <!-- 二级菜单列表：全部分类目录平铺，分类名作为小标题 -->
    <div class="menu-area" ref="menuArea" @scroll="onScroll">
      <template v-for="(item, index) in menus">
        <!-- 分类小标题（分组标题，id 供一级图标点击滚动定位，data-group-key 供滚动监听定位） -->
        <div
          v-if="item.isGroup"
          :key="item.key"
          :id="'menu-group-' + item.key"
          :data-group-key="item.key"
          class="menu-group-title"
          @click="handleClick(item)"
        >
          <span>{{ item.title }}</span>
        </div>

        <!-- 子级：筛选模板（保留兼容） -->
        <div
          v-else-if="item.isFilterTemplate"
          :key="item.key"
          class="menu-item menu-child"
          :class="{ active: activeKey === item.key }"
          @click="handleClick(item)"
        >
          <span class="tpl-icon">⭐</span>
          <span class="menu-title">{{ item.title }}</span>
        </div>

        <!-- 业务目录：点击跳转对应 URL -->
        <div
          v-else
          :key="item.key"
          class="menu-item menu-directory"
          :class="{ active: activeKey === item.key }"
          @click="handleClick(item)"
        >
          <span class="menu-title">{{ item.title }}</span>
          <!-- 开发中胶囊 -->
          <span v-if="item.isDev" class="dev-tag">开发中</span>
          <!-- 角标：支持4种级别；灰色角标(gray-text)为低优先级数字提示，0 也显示 -->
          <span v-if="item.badgeType === 'gray-text' ? item.badge >= 0 : item.badge > 0" 
                class="menu-badge"
                :class="'badge-' + (item.badgeType || 'red-bg')"
          >
            {{ item.badge }}
          </span>
        </div>
      </template>
    </div>

    <!-- 空状态 -->
    <div class="empty-state" v-if="menus.length === 0">
      <a-icon type="inbox" />
      <p>请选择左侧菜单</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubSidebarMenu',
  props: {
    title: {
      type: String,
      default: ''
    },
    menus: {
      type: Array,
      default: () => []
    },
    activeKey: {
      type: String,
      default: ''
    }
  },
  computed: {
    hasTitle() {
      // 有 title prop 或者有 title slot 时才显示
      return this.title || this.$slots.title
    }
  },
  methods: {
    handleClick(item) {
      this.$emit('select', item)
    },
    // 二级菜单滚动：转发给父级做图标栏联动（scroll-spy）
    onScroll(e) {
      this.$emit('scroll', e)
    }
  }
}
</script>

<style scoped>
.sub-sidebar-menu {
  width: 100%;
  height: 100%;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

.sub-title {
  height: 49px;
  display: flex;
  align-items: center;
  padding: 0 8px;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #f0f0f0;
}

.menu-area {
  flex: 1;
  padding: 12px 8px;
  overflow-y: auto;
  position: relative; /* 让分组标题 offsetTop 相对本容器，供滚动联动计算 */
}

/* 滚动条：默认隐藏，hover 容器时显示（表格同款） */
.menu-area::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.menu-area::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 4px;
}

.menu-area::-webkit-scrollbar-track {
  background: transparent;
}

/* 滚动条：默认隐藏，HOVER 整个目录栏（含标题区）时显示（表格同款） */
.sub-sidebar-menu:hover .menu-area::-webkit-scrollbar-thumb {
  background: #c1c1c1;
}

.menu-area::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8 !important;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 4px;
  transition: all 0.2s;
  color: #666;
  font-size: 14px;
}

/* 分类小标题（分组标题） */
.menu-group-title {
  padding: 16px 16px 6px;
  font-size: 12px;
  font-weight: 600;
  color: #333;
  cursor: default;
  user-select: none;
  letter-spacing: 1px;
}

/* 业务目录项（缩进在分类小标题下） */
.menu-directory {
  padding: 9px 16px 9px 22px;
  font-size: 13px;
  color: #666;
  margin-bottom: 2px;
}

.menu-directory:hover {
  background: #e7edf5;
  color: #333;
}

.menu-directory.active {
  background: #e7edf5;
  color: #1890ff;
  font-weight: 500;
}

/* 子级菜单（筛选模板） */
.menu-child {
  padding: 8px 12px 8px 24px;
  font-size: 13px;
  color: #666;
  margin-bottom: 2px;
  position: relative;
}

.menu-child .tpl-icon {
  font-size: 12px;
  margin-right: 6px;
  color: #faad14;
}

.menu-child:hover {
  background: #e7edf5;
  color: #333;
}

.menu-child.active {
  background: #e7edf5;
  color: #1890ff;
}

.menu-badge {
  font-size: 12px;
  margin-left: 8px;
  min-width: 20px;
  text-align: center;
}

/* 开发中胶囊（与 header 顶栏「开发中」样式统一：黄字淡黄底） */
.dev-tag {
  font-size: 11px;
  line-height: 16px;
  color: #faad14;
  background: #fffbe6;
  border: 1px solid #ffe58f;
  padding: 0 8px;
  border-radius: 8px;
  margin-left: 6px;
  flex-shrink: 0;
}

/* 角标：支持4种级别 */
.badge-gray-text {
  background: #f0f0f0;
  color: #666;
  padding: 1px 6px;
  border-radius: 10px;
}

.badge-red-text {
  background: #fff2f0;
  color: #ff4d4f;
  padding: 1px 6px;
  border-radius: 10px;
}

.badge-red-bg {
  background: #ff4d4f;
  color: white;
  padding: 1px 6px;
  border-radius: 10px;
}

.empty-state {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 13px;
}

.empty-state i {
  font-size: 32px;
  margin-bottom: 8px;
}
</style>
